import { render, staticRenderFns } from "./YesNoButtonList.vue?vue&type=template&id=40b4cf2c&"
import script from "./YesNoButtonList.vue?vue&type=script&lang=js&"
export * from "./YesNoButtonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports